function openAccordion(){
  $('.content-fixed .close').on('click', function() {
    $('.accordion[open] summary').click();
    return false;
  });
}

/*--------------------------------------------------
DOC READY
--------------------------------------------------*/
$(document).ready(function(e) {
    openAccordion();
});